<div class="municipality-payment-container" id="municipality-payment-page" *ngIf="isViewServiceHistoryScreen">
  <ptg-breadcrumb
    [listBreadcrumbs]="listBreadcrumbs"
  ></ptg-breadcrumb>
  <div *ngIf="!isEntityView; else entityView">
    <ptg-overview-header
      #overViewHeader
      (changeMemberDetailEvent)="onChangeMemberDetail()"
    ></ptg-overview-header>
  </div>
  <ng-template #entityView>
    <ptg-overview-header-entity [shouldHideStatusDateProperty]="true" [shouldHideStatusEventProperty]="true"></ptg-overview-header-entity>
  </ng-template>

  <div class="flex flex-col p-6 gap-6">
    <ptg-banner
      *ngIf="bannerType"
      [(bannerType)]="bannerType"
      [message]="message"
    ></ptg-banner>

    <ptg-municipality-group-aggregation [aggregationDetails]="listAggregations">
    </ptg-municipality-group-aggregation>

    <ptg-detail-display-box
      *ngIf="dataTable && dataTable.length"
      title="Selected Service"
      [selectedItem]="dataTable[currentRowIndex]"
      [propertyDisplayed]="propertyDisplayed"
      (editButtonEvent)="onEditServiceHistory(dataTable[currentRowIndex])"
      [employerPortalId]="employerPortalId"
      [shouldHideSeperator]="!(dataTable[currentRowIndex].municipalityId === employerPortalId) || !isShowEditBtnByPermission"
      [isContentLoading]="isLoading"
      [shouldShowEditBtn]="isShowEditBtnByPermission"
    ></ptg-detail-display-box>

    <ptg-list-display-box
      title="Service History"
      pageName="{{ currentPageName || menuName }}"
      [btnAddTitle]="isShowAddBtnByPermission ? 'Add' : ''"
      [isLoading]="isLoading"
      [dataTable]="dataTable"
      [columns]=" isMuniPortal ? muniPortalcolumns : columns"
      [sortInfo]="sortInfo"
      [lengthPg]="lengthPg"
      [pageSize]="pageSize"
      [pageNumber]="pageNumber"
      [currentRowIndex]="currentRowIndex"
      [isMuniPortal]="isMuniPortal"
      (changePage)="changePage($event)"
      (sortChange)="sortChange($event)"
      (selectRow)="selectRow($event)"
      (addItem)="onEditServiceHistory(undefined)"
      [shouldHideSeperator]="true"
    ></ptg-list-display-box>
  </div>
</div>
<div *ngIf="!isViewServiceHistoryScreen" class="no-permission">
  <p>You don't have permission to view this screen.</p>
</div>
